/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
import React, { Suspense } from 'react';
import { createRoot } from 'react-dom/client';
import { ThemeProvider } from 'styled-components';
import adListener from 'utils/adListener';
import { getAdMethods } from 'utils/adMethods';
import keyboard from 'utils/keyboard';
import playerListener from 'utils/playerListener';
import { initPlayerMethods } from 'utils/playerMethods';
import 'utils/skinUtilsStub';
import { playerContext } from './contexts/player-contenxt';
import { processPlayerStateCallbacksV2 } from './utils/playerStateListener';

const Skin = React.lazy(
  () =>
    import(/* webpackChunkName: "mggp-skin" */ './containers/SkinRoot/SkinRoot')
);

let playerAPI: {
  playerMethods: ReturnType<typeof initPlayerMethods>;
  adMethods: Record<string, (...args: any[]) => void>;
  getState: () => PlayerState;
} = {
  playerMethods: {} as any,
  adMethods: {},
  getState: (() => {}) as any,
};

export function getPlayerAPI() {
  return playerAPI;
}

export let playerMethods: ReturnType<typeof initPlayerMethods>;

const initSkin = (
  player: Player,
  container: HTMLElement,
  onSkinMounted: () => void
) => {
  (window as any).brandColor = [];
  (window as any).brandColorOver = [];
  (window as any).additionalColor = [];
  (window as any).skinConsts = {};
  playerMethods = initPlayerMethods(player, getState);
  const adMethods = getAdMethods(player);

  playerAPI = {
    playerMethods,
    adMethods,
    getState,
  };

  const theme = {
    main: 'main_color_cms',
    main_default: 'main_default_color_cms',
    main_bg: 'main_bg_cms',
    main_hover_color: 'main_hover_color_cms',
  };

  const reactRoot = createRoot(container);

  addGlobalStyles();

  keyboard(player, getState, playerMethods);

  let state: PlayerState = {
    ...playerListener(player, onUpdate, getState),
    ...adListener(player, onUpdate, getState),
  } as any; // TODO:

  let render = updateSkins;
  if (process.env.NODE_ENV === 'development') {
    render = withCallCount(updateSkins, (count: number) =>
      // eslint-disable-next-line no-console
      console.log(`Average render ${(count / 60).toFixed(2)} CpS.`)
    );
    player.utils = player.utils || {};
    player.utils.withCallCount = withCallCount;
  }

  render(state);

  function onUpdate(updatedData: Partial<PlayerState>) {
    state = {
      ...state,
      ...updatedData,
    };
    render(state);

    // const start = performance.now();
    processPlayerStateCallbacksV2(updatedData, state);
    // const d = (performance.now() - start) * 1000;

    // console.log(add(d));
  }

  // function getAdd() {
  //   const arr: number[] = [];
  //   let pointer = 0;

  //   return (item: number): number => {
  //     arr[pointer++] = item;

  //     if (pointer >= 1001) {
  //       pointer = 0;
  //     }

  //     const sum = arr.reduce<number>((sum, item) => sum + item, 0);
  //     return sum / arr.length;
  //   };
  // }

  // const add = getAdd();

  /*******
   * Maybe need to move this registrations into the separate module
   * *******/
  player.registerProperty(
    'getIsLinearHybridAdShowed',
    () => state.adLinear && state.adPlaying && state.isHybridAdSkin,
    true
  );

  player.registerProperty('getMessageModeData', () => state.messageModeData);
  /******************/

  function updateSkins(data: PlayerState) {
    reactRoot.render(
      <ThemeProvider theme={theme}>
        <playerContext.Provider
          value={{
            API: playerMethods,
            properties: state,
          }}
        >
          <Suspense fallback={<div />}>
            <Skin
              onMounted={onSkinMounted}
              data={data}
              playerMethods={playerMethods}
              adMethods={adMethods}
              socials={player.config.socials}
              userId={player.config.userID}
            />
          </Suspense>
        </playerContext.Provider>
      </ThemeProvider>
    );
  }

  function getState() {
    return state;
  }
};

function withCallCount(
  fn: (...args: any[]) => void,
  effect = Function.prototype
) {
  let count = 0;
  setInterval(() => {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-call
    effect(count);
    count = 0;
  }, 60000);

  return function (...args: any[]) {
    count++;
    // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
    return fn(...args);
  };
}

export default initSkin;

function addGlobalStyles() {
  const style = document.createElement('style');
  style.innerHTML = `
    html {
      -ms-text-size-adjust: 100%;                       /* 2 */
      -webkit-text-size-adjust: 100%;                   /* 2 */
      -webkit-tap-highlight-color: rgba(0, 0, 0, 0);    /* 3 */
      -webkit-focus-ring-color: rgba(255, 255, 255, 0); /* 3 */
      cursor: default;                                  /* 4 */
    }

    [hidden] {
      display: none;
    }
    
    button,
    html input[type='button'],
    input[type='reset'],
    input[type='submit'] {
      -webkit-appearance: button;
      cursor: pointer;
    }
    
    button[disabled],
    html input[disabled] {
      cursor: default;
    }

    #mggp-player-wrapper::after {
      content: '';
      position: absolute;
      height: 100%;
      width: 100%;
      top: 0;
      left: 0;
      background-color: #000;
      z-index: -1;
    }
    
    #playerContainer *:not(input, textarea) {
      user-select: none;
      -webkit-user-select: none;
    }

    #mggp-video-container video {
      width: 100%;
      height: 100%;
    }
  `;
  document.head.appendChild(style);
}
